'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _jsxFileName = 'src/new-business/stage4/components/form.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _constants = require('@marmalade/constants');
var _constants2 = _interopRequireDefault(_constants);
var _arrayToIso = require('@marmalade/date/lib/array-to-iso');
var _arrayToIso2 = _interopRequireDefault(_arrayToIso);
var _domain = require('@marmalade/domain');
var _domain2 = _interopRequireDefault(_domain);
var _validation = require('@marmalade/form/lib/actions/validation');
var _checkboxStacked = require('@marmalade/form/lib/components/checkbox/checkbox-stacked');
var _checkboxStacked2 = _interopRequireDefault(_checkboxStacked);
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _formNavigation = require('@marmalade/form/lib/components/form-navigation');
var _formNavigation2 = _interopRequireDefault(_formNavigation);
var _radio = require('@marmalade/form/lib/components/radio');
var _scrollToError = require('@marmalade/form/lib/components/scroll-to-error');
var _scrollToError2 = _interopRequireDefault(_scrollToError);
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _isInternal = require('@marmalade/is-internal');
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _panel = require('@marmalade/panel');
var _glamorous = require('glamorous');
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _constants3 = require('../../../constants');
var _renderIfBroker = require('../../../render-if-broker');
var _renderIfBroker2 = _interopRequireDefault(_renderIfBroker);
var _stage = require('../../../validation/new-business/stage4');
var _stage2 = _interopRequireDefault(_stage);
var _makePayment = require('../../actions/make-payment');
var _makePayment2 = _interopRequireDefault(_makePayment);
var _constants4 = require('../../constants');
var _selectors = require('../../selectors');
var _charityDonationPanel = require('./charity-donation-panel');
var _charityDonationPanel2 = _interopRequireDefault(_charityDonationPanel);
var _coverPanel = require('./cover-panel');
var _coverPanel2 = _interopRequireDefault(_coverPanel);
var _quoteSummaryPanel = require('./quote-summary-panel');
var _quoteSummaryPanel2 = _interopRequireDefault(_quoteSummaryPanel);
var _statements = require('./statements');
var _statements2 = _interopRequireDefault(_statements);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants4.stages[3].formId;
var NewStage4Form = function (_Component) {
  _inherits(NewStage4Form, _Component);
  function NewStage4Form() {
    var _ref,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, NewStage4Form);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewStage4Form.__proto__ || Object.getPrototypeOf(NewStage4Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      error: ''
    }, _this.handleSubmit = function () {
      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(formState) {
        var resError;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!formState.validAndPristine) {
                  _context.next = 12;
                  break;
                }
                _context.prev = 1;
                _context.next = 4;
                return _this.props.serverSideValidation({
                  formId: formId,
                  validationUrl: _constants4.validationUrl,
                  requiredStrings: _constants4.stages[3].requiredStrings,
                  requiredDates: _constants4.stages[3].requiredDates,
                  extraData: {
                    guid: _this.props.guid,
                    dateOfBirth: (0, _arrayToIso2.default)(_this.props.dateOfBirth),
                    licenceStartDate: (0, _arrayToIso2.default)(_this.props.licenceStartDate)
                  },
                  callback: function callback() {
                    return _this.props.makePayment(_this.props.theme);
                  }
                });
              case 4:
                _context.next = 12;
                break;
              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);
                if (_context.t0.response) {
                  _context.next = 10;
                  break;
                }
                throw _context.t0;
              case 10:
                resError = _context.t0.response.data.error;
                // Catch error from server to show as generic message

                _this.setState(Object.assign({}, _this.state, {
                  error: resError.description ? resError.description : resError.value
                }), function () {
                  return window.scrollTo(0, 0);
                });
              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 6]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(NewStage4Form, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91
        },
        __self: this
      }, _react2.default.createElement(_form2.default, {
        id: formId,
        handleSubmit: this.handleSubmit,
        product: 'ldi',
        validator: (0, _stage2.default)({
          licenceStartDate: this.props.licenceStartDate,
          dateOfBirth: this.props.dateOfBirth
        }),
        preventSubmitOnEnterKey: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        },
        __self: this
      }, _react2.default.createElement('h1', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102
        },
        __self: this
      }, _constants4.stages[3].name), (this.props.hasErrors || this.state.error) && _react2.default.createElement(_message2.default, {
        type: 'error',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104
        },
        __self: this
      }, this.state.error ? this.state.error : this.props.priceChangeError || 'There are some errors in the details you provided, please check them carefully and try\n                            again.'), _react2.default.createElement(_scrollToError2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 112
        },
        __self: this
      }), _react2.default.createElement(_coverPanel2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        },
        __self: this
      }), _react2.default.createElement(_charityDonationPanel2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        },
        __self: this
      }), _react2.default.createElement(_panel.PanelAside, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: this
      }, _react2.default.createElement(_statements2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 116
        },
        __self: this
      }), _react2.default.createElement(_radio.RadioYesNo, {
        name: 'statements',
        label: 'All of the above 6 statements apply to me and I wish to proceed with a Learner Driver Insurance Policy:',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117
        },
        __self: this
      }), _react2.default.createElement(_radio.RadioYesNo, {
        name: 'policySummary',
        label: _react2.default.createElement('span', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 124
          },
          __self: this
        }, 'I have read and understood the', ' ', _react2.default.createElement('a', {
          href: (0, _domain2.default)('api.wearemarmalade') + '/proxy/document.php?product=1&documentType=9&return=download',
          target: '_blank',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 126
          },
          __self: this
        }, 'Insurance Product Information Document'), ' ', 'for the Learner Driver Insurance Policy:'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        },
        __self: this
      })), _react2.default.createElement(_quoteSummaryPanel2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 139
        },
        __self: this
      }), this.props.applicationError ? _react2.default.createElement(_message2.default, {
        type: 'error',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 141
        },
        __self: this
      }, 'Sorry, there was a problem submitting your application. Please call', ' ', _constants2.default.contact.phone.general, ' for assistance.') : null, this.props.applicationError && this.props.isInternal ? _react2.default.createElement(_message2.default, {
        type: 'warning',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 147
        },
        __self: this
      }, 'Please check if the customer has already had a policy with Marmalade') : null, _react2.default.createElement(_renderIfBroker2.default, {
        checkboxName: 'broker_stage_4',
        options: [{
          text: 'Please confirm the statements above have been read to the customer.',
          value: 'true'
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160
        },
        __self: this
      }, 'Hurry up and finish me')), !_constants3.IS_LIVE_SITE && this.props.isInternal ? _react2.default.createElement('div', {
        style: {
          display: 'flex',
          justifyContent: 'flex-end'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165
        },
        __self: this
      }, _react2.default.createElement(_checkboxStacked2.default, {
        name: 'payByTelephony',
        options: [{
          text: 'Use telephony system for card payment',
          value: 'checked'
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166
        },
        __self: this
      })) : null, _react2.default.createElement(_formNavigation2.default, {
        next: {
          submit: true,
          text: 'Make payment',
          posting: this.props.posting,
          id: 'ldi-new-payment'
        },
        prev: {
          text: 'Back',
          link: this.props.linkPrefix + '/stage3'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173
        },
        __self: this
      })));
    }
  }]);
  return NewStage4Form;
}(_react.Component);
NewStage4Form.propTypes = {
  linkPrefix: _propTypes.string.isRequired,
  applicationError: _propTypes.bool.isRequired,
  posting: _propTypes.bool.isRequired,
  isInternal: _propTypes.bool.isRequired,
  licenceStartDate: _propTypes.array.isRequired,
  dateOfBirth: _propTypes.array.isRequired,
  serverSideValidation: _propTypes.func.isRequired,
  makePayment: _propTypes.func.isRequired,
  policyId: _propTypes.number,
  hasErrors: _propTypes.bool.isRequired,
  priceChangeError: _propTypes.string,
  theme: _propTypes.object
};
NewStage4Form.defaultProps = {
  guid: undefined
};
exports.default = (0, _glamorous.withTheme)((0, _reactRedux.connect)(function (state) {
  return {
    policyId: state.ldiQuote.policy.id,
    applicationError: (0, _selectors.applicationError)(state),
    posting: (0, _formInfo.isSubmittingForm)(state, formId),
    licenceStartDate: (0, _fieldInfo.getValue)(state, _constants4.stages[1].formId, 'licenceStartDate'),
    dateOfBirth: (0, _fieldInfo.getValue)(state, _constants4.stages[1].formId, 'dateOfBirth'),
    isInternal: (0, _isInternal.isInternal)(state),
    hasErrors: (0, _formInfo.hasErrors)(state, formId),
    priceChangeError: (0, _fieldInfo.getError)(state, formId, 'priceChange')
  };
}, {
  serverSideValidation: _validation.serverSideValidation,
  makePayment: _makePayment2.default
})(NewStage4Form));